import styled from 'styled-components'
import { breakpoints } from '../assets/styles/mediaBreakpoints'

const ContactPage = () => {
  return (
    <ContactSection>
      <h1>Contact Us</h1>
      <TextContainer>
        <p>
          We’re here to connect, collaborate, and support your journey toward
          creating a better world. Whether you have questions, feedback, or
          ideas to share, the Community of Guardians team is ready to assist.
        </p>
      </TextContainer>
      <TextContainer>
        <h6>Email us</h6>
        <p>For general inquiries, email us at: chiefguardian@cogsmail.com</p>
      </TextContainer>
      <TextContainer>
        <h6>Call us</h6>
        <p>Reach our support team at: +1 519-719-2926</p>
      </TextContainer>
    </ContactSection>
  )
}

const ContactSection = styled.div`
  display: flex;
  flex-direction: column;
  background: radial-gradient(
    ellipse 150% 100% at top,
    ${(props) => props.theme.colors['primary-500']} 0%,
    white 70%
  );
  width: 100%;
  padding: 120px 0;
  gap: 16px;
  justify-content: center;
  align-items: center;
  @media (max-width: ${breakpoints.desktop}px) {
    padding: 80px 24px;
  }
`
const TextContainer = styled.div`
  text-align: center;
  max-width: 640px;
  gap: 8px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${breakpoints.desktop}px) {
    max-width: auto;
  }
`

export default ContactPage
